import type { ReactNode } from "react";
import { createElement, Fragment } from "react";

export const PHONE_NUMBER_PLACEHOLDER = "{phoneNumber}";

export const renderPhoneTemplateText = (
  textTemplate: string,
  phoneNumber: string,
  renderPhoneNumber: (phoneNumber: string) => ReactNode,
): ReactNode => {
  const [beforePhoneNumber, afterPhoneNumber = ""] = textTemplate.split(PHONE_NUMBER_PLACEHOLDER);

  if (!textTemplate.includes(PHONE_NUMBER_PLACEHOLDER)) {
    return textTemplate;
  }

  return createElement(
    Fragment,
    null,
    beforePhoneNumber,
    renderPhoneNumber(phoneNumber),
    afterPhoneNumber,
  );
};
